/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pilot_Ended_Body_ShortInputs */



/**
* | output |
* | --- |
* | "Your pilot is over. Your account is closed. Your practice conversations and preparations are no longer available." |
*
* @param {Pilot_Ended_Body_ShortInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const pilot_ended_body_short = /** @type {((inputs?: Pilot_Ended_Body_ShortInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pilot_Ended_Body_ShortInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je pilot zit erop. Je account is afgesloten. Je oefengesprekken en voorbereidingen zijn niet meer beschikbaar.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre pilote est terminé. Votre compte est clôturé. Vos conversations d’entraînement et vos préparations ne sont plus disponibles.")
	return /** @type {LocalizedString} */ ("Your pilot is over. Your account is closed. Your practice conversations and preparations are no longer available.")
});